
define('template!ordersDetailCompositionAiDesignTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="cad-popup">\n  <div class="cad-head">\n    <div class="cad-zone">\n      <span class="cad-zone-name">' +
((__t = ( zoneLabel )) == null ? '' : __t) +
'</span>\n      ';
 if (zoneSize) { ;
__p += '<span class="cad-zone-size">' +
((__t = ( zoneSize )) == null ? '' : __t) +
'</span>';
 } ;
__p += '\n    </div>\n    <div class="cad-constraints js-constraints">\n      <div class="cad-loading">' +
((__t = ( _.i18n('orders.detail.composition.aiDesign.loadingBrief', null, 'Reading the printing constraints…') )) == null ? '' : __t) +
'</div>\n    </div>\n  </div>\n\n  <div class="cad-form">\n    <label class="cad-label" for="cad-prompt">\n      ' +
((__t = ( _.i18n('orders.detail.composition.aiDesign.promptLabel', null, 'What do you want on the print zone?') )) == null ? '' : __t) +
'\n    </label>\n    <textarea id="cad-prompt" class="cad-prompt js-prompt" rows="3" maxlength="2000"\n      placeholder="' +
((__t = ( _.i18n('orders.detail.composition.aiDesign.promptPlaceholder', null, 'e.g. the customer logo above the slogan \'Summer tour 2026\', mountain silhouette in the background') )) == null ? '' : __t) +
'"></textarea>\n\n    <div class="cad-reference">\n      <div class="cad-label">\n        ' +
((__t = ( _.i18n('orders.detail.composition.aiDesign.referenceLabel', null, 'Reference image (optional): a logo or artwork the design must include') )) == null ? '' : __t) +
'\n      </div>\n      <div class="cad-reference-list js-references"></div>\n      <label class="cad-upload">\n        <i class="mdi-file-cloud-upload"></i>\n        <span>' +
((__t = ( _.i18n('orders.detail.composition.aiDesign.uploadReference', null, 'Upload a file to the order attachments') )) == null ? '' : __t) +
'</span>\n        <input type="file" class="js-upload" accept="image/png,image/jpeg,image/webp,application/pdf">\n      </label>\n    </div>\n\n    <div class="cad-actions">\n      <button type="button" class="btn btn-primary cad-generate js-generate" disabled>\n        <i class="mdi-image-brush"></i>\n        <span>' +
((__t = ( _.i18n('orders.detail.composition.aiDesign.generate', null, 'Generate') )) == null ? '' : __t) +
'</span>\n      </button>\n      <span class="cad-cost">' +
((__t = ( _.i18n('orders.detail.composition.aiDesign.cost', null, 'One paid OpenAI call, 30 to 90 seconds.') )) == null ? '' : __t) +
'</span>\n    </div>\n  </div>\n\n  <div class="cad-result js-result"></div>\n</div>\n';

}
return __p
};});

